import { render, staticRenderFns } from "./buisiness.vue?vue&type=template&id=94214430"
import script from "./buisiness.vue?vue&type=script&lang=js"
export * from "./buisiness.vue?vue&type=script&lang=js"
import style0 from "./buisiness.vue?vue&type=style&index=0&id=94214430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports